module.exports = __webpack_public_path__ + "static/img/video2.b9b7fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/video2.png
// module id = HODg
// module chunks = 12